import { usePostHogAnalytics } from '../../hooks/usePostHogAnalytics';

/** Sincroniza identify e pageviews com o PostHog. */
export function PostHogAnalytics() {
  usePostHogAnalytics();
  return null;
}
